import { Injectable, Output, EventEmitter } from '@angular/core';
import {EndpointService} from "../../services/endpoint/endpoint.service";
import {Observable} from "rxjs";


    @Injectable({
    providedIn: 'root'
    })

export class MessagesService {
    @Output() returnMessageCount: EventEmitter<any> = new EventEmitter();
    @Output() returnMessageObject: EventEmitter<any> = new EventEmitter();
    local_newMsg_count: number;
    user_name;


    constructor(
        private endpointSrv: EndpointService,

    ) {

     }

    get_all_users_MSG_by_id_Request() {
        return new Observable((observer)=>{
            this.endpointSrv.get_all_users_MSG_by_id_Request().subscribe((get_all_users_MSG_by_id_Request)=>{
                observer.next(get_all_users_MSG_by_id_Request);
            });
        });
    }
    getMessageCount() {
        return new Observable((observer)=>{
            this.endpointSrv.getUserMessageCountRequest().subscribe((getMessageCount)=>{
                this.local_newMsg_count = getMessageCount['number_of_user_message']
                this.returnMessageCount.emit(this.local_newMsg_count)
                observer.next(getMessageCount);
            });
        });
    }
    getMessageCountEmitter(){
        return this.returnMessageCount;
    }
    setNewObject(item){
        this.returnMessageObject.emit(item);
        this.user_name = item;
    }
    getNewObject(){
        return this.returnMessageObject;
    }
    getMessageCountForUser(){
        return this.local_newMsg_count;
    }
    getUserName(){
        return this.user_name
    }


}
